import { types } from "mobx-state-tree";

export default types
  .model("ChatRoomTag", {
    id: types.number,
    chatRoomId: types.identifier,
    tag: types.number,
  })
  .actions((self) => ({
    update(values) {
      Object.assign(self, values);
      return self;
    },
  }));
